import React from 'react';

const CmdInput = (props: { cmd: string }) => (
  <div className="tw-inline-flex tw-items-center tw-justify-center tw-font-mono tw-bg-zinc-900 dark:tw-bg-zinc-200 tw-text-primary-inverted tw-text-sm tw-pt-1 tw-px-2 tw-rounded">
    {props.cmd}
  </div>
);

export default CmdInput;
